import styled from 'styled-components'

/** @param {{ small?: boolean }} props */
const size = props => (props.small ? '18px' : '24px')

const Display4 = styled.span`
  color: ${props => (props.color ? props.color : '#333333')};
  font-family: 'NotoSans';
  font-weight: 800;
  font-size: ${size};
  line-height: 18px;
`

export default Display4



// WEBPACK FOOTER //
// ./src/lib/typography/Display4.jsx